module.exports = __webpack_public_path__ + "media/images/icons/outlined/pic-right-2ae7568ac9857e63acb288dec45134ce.svg";